import { render, staticRenderFns } from "./B2bPartner.vue?vue&type=template&id=003238b6&"
import script from "./B2bPartner.vue?vue&type=script&lang=js&"
export * from "./B2bPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports